<template>
    <div id="start-page">
        <Errors :error-information="errorInformation"/>
        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.start }">
                <h5>Start- und Ziel-Stadt des Fluges</h5>
                <vue-google-autocomplete
                    id="start"
                    ref="start"
                    placeholder="Von"
                    v-on:placechanged="setStartAddress"
                    @change="setStartText"
                    v-on:focus="resetStartAddress"
                    types="airport"
                    v-model="caseData.start"
                >
                </vue-google-autocomplete>
                <small class="error" v-if="validation.validationErrors.start">
                    Ihre Eingabe ist nicht eindeutig. Bitte wählen Sie eine Stadt aus dem Dropdown-Menü aus.
                </small>
            </div>
        </div>

        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.end }">
                <vue-google-autocomplete
                    id="end"
                    ref="end"
                    placeholder="Nach"
                    v-on:placechanged="setEndAddress"
                    @change="setEndText"
                    v-on:focus="resetEndAddress"
                    types="airport"
                    v-model="caseData.end"
                >
                </vue-google-autocomplete>
                <small class="error" v-if="validation.validationErrors.end">
                    Ihre Eingabe ist nicht eindeutig. Bitte wählen Sie eine Stadt aus dem Dropdown-Menü aus.
                </small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.stopover }">
                <button v-model="viewData.hasStopover" @click.stop="toogleStopover" class="button tiny" :class="{ alert: viewData.hasStopover }">
                    {{ stopoverButtonText }}
                </button>
                <div v-if="viewData.hasStopover">
                    <vue-google-autocomplete
                        id="stopover"
                        ref="stopover"
                        placeholder="Zwischenstopp"
                        @change="setStopoverText"
                        types="airport"
                        v-model="caseData.stopover"
                    >
                    </vue-google-autocomplete>
                    <small class="error" v-if="validation.validationErrors.stopover">
                        Ihre Eingabe ist nicht eindeutig. Bitte wählen Sie eine Stadt aus dem Dropdown-Menü aus.
                    </small>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns">
                <h5>Die Flugverbindung ...</h5>
                <label class="row collapse" v-for="caseType in availableCaseTypes" :key="caseType.value">
                    <div class="columns small-1">
                        <input type="radio" name="type" :value="caseType.value" v-model="caseData.type"/>
                    </div>
                    <div class="columns small-11">{{ caseType.title }}</div>
                </label>
                <small class="error" v-if="validation.validationErrors.type">Bitte wählen Sie eine Antwort aus.</small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.flightdate }">
                <h5>Datum des Fluges</h5>
                <datepicker
                    v-model="dates.flightdate"
                    name="uniquename"
                    input-class="short"
                    :language="de"
                    :disabled-dates="datepickerDisabledDates"
                    :monday-first="true"
                    placeholder="Datum"
                    format="dd. MMM. yyyy"
                    @selected="selectFlightdate"
                />
                <small class="error" v-if="validation.validationErrors.flightdate">Bitte wählen Sie ein Datum aus.</small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.plannedRelevantDate }">
                <h5>{{plannedRelevantDateLabel}}</h5>
                <datetime
                    v-model="caseData.planned_relevant_date"
                    type="datetime"
                    :title="plannedRelevantDateTitle"
                    :phrases="{ ok: 'Ok', cancel: 'Abbrechen' }"
                    :max-datetime="maxDatetime"
                    input-class="short"
                    zone="Europe/Berlin"
                    value-zone="Europe/Berlin"
                />
                <small class="error" v-if="validation.validationErrors.plannedRelevantDate">Bitte wählen Sie eine Zeit aus.</small>
            </div>
        </div>

        <div class="row">
            <div class="small-12 medium-6 columns"
                 v-bind:class="{error: validation.validationErrors.actualRelevantDate, error: validation.validationErrors.actualRelevantDateNotArrived}">
                <h5>{{actualRelevantDateLabel}}</h5>
                <datetime
                    v-model="caseData.actual_relevant_date"
                    type="datetime"
                    :title="actualRelevantDateTitle"
                    :phrases="{ ok: 'Ok', cancel: 'Abbrechen' }"
                    :max-datetime="maxDatetime"
                    input-class="short"
                    zone="Europe/Berlin"
                    value-zone="Europe/Berlin"
                    :disabled="isActualRelevantDateDisabled"
                ></datetime>
                <small class="error" v-if="validation.validationErrors.actualRelevantDate">
                    Bitte wählen Sie eine Zeit aus.
                </small>
                <small class="error" v-if="validation.validationErrors.actualRelevantDateNotArrived">
                    Bitte wählen Sie <strong>entweder</strong> die tatsächliche Ankunftszeit aus <strong>oder</strong> die Option "Flug wurde nicht angetreten".
                </small>
                <span v-if="isCaseTypeCanceled">
                      <label>
                          <input type="checkbox" class="checkbox-margin" v-model="viewData.hasNotArrived" value="1"/>
                          Ziel wurde nicht erreicht (da kein Ersatzflug angetreten wurde).
                      </label>
                </span>
            </div>
        </div>
        <template v-if="isCaseTypeNoBoarding">
            <div class="row">
                <div class="small-12 medium-6 columns">
                    <h5>
                        Waren Sie rechtzeitig am Check-In-Schalter und am Gate/Flugsteig?
                    </h5>

                    <label v-for="radioValue in wasLateForBoardingRadioValue" :key="radioValue.value" class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" :value="radioValue.value" name="was_late_for_boarding"
                                   v-model="caseData.was_late_for_boarding"/>
                        </div>
                        <div class="columns small-11">{{radioValue.text}}</div>
                    </label>
                    <small class="error" v-if="validation.validationErrors.wasLateForBoarding">
                        Bitte wählen Sie eine Antwort aus.
                    </small>
                </div>
            </div>
            <div class="row">
                <div class="small-12 medium-6 columns">
                    <h5>
                        Wurde Ihnen die Beförderung aufgrund von Krankheit oder Sicherheitsbedenken untersagt?
                    </h5>

                    <label v-for="radioValue in defaultRadioValues" :key="radioValue.value" class="row collapse">
                        <div class="columns small-1">
                            <input type="radio" :value="radioValue.value" name="was_boarding_lateness_acceptable"
                                   v-model="caseData.was_boarding_lateness_acceptable"/>
                        </div>
                        <div class="columns small-11">{{radioValue.text}}</div>
                    </label>
                    <small class="error" v-if="validation.validationErrors.wasBoardingLatenessAcceptable">
                        Bitte wählen Sie eine Antwort aus.
                    </small>
                </div>
            </div>
        </template>
        <div class="row" v-else>
            <div class="small-12 medium-6 columns">
                <h5>
                    Was war der Grund für die <span>{{reasonText}}</span>?
                </h5>
                <label class="row collapse" v-for="causeType in availableCauseTypes" :key="causeType.value">
                    <div class="columns small-1">
                        <input type="radio" name="cause" :value="causeType.value" v-model="caseData.cause"/>
                    </div>
                    <div class="columns small-11">
                        {{causeType.title}}
                    </div>
                </label>
                <small class="error" v-if="validation.validationErrors.cause">Bitte wählen Sie eine Antwort aus.</small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.mainAirlineId }">
                <label>
                    <h5>
                        {{ mainAirlineNameFieldText }}
                    </h5>
                    <p style="font-size: small; margin: 0;">
                        Hier die Fluglinie eintragen, die den ursprünglich annullierten, verspäteten oder vorverlegten Flug
                        <em>durchgeführt</em> hat oder durchführen sollte (wichtig wenn der Flug über eine andere
                        Fluglinie gebucht wurde).
                    </p>
                </label>
                <vue-simple-suggest
                    display-attribute="name"
                    value-attribute="name"
                    :list="airlines"
                    :filter-by-query="true"
                    :debounce="200"
                    @select="onSuggestSelectMainAirline"
                    v-model="viewData.mainAirlineName"
                />
                <div class="alert-box alert" v-if="mainAirlineCodeHintText">
                    {{ mainAirlineCodeHintText }}
                </div>
                <small class="error" v-if="validation.validationErrors.mainAirlineId">
                    Bitte wählen Sie eine Fluglinie aus der Liste aus.
                </small>
            </div>
        </div>

        <div class="row">
            <div class="small-12 medium-3 columns" v-bind:class="{ error: validation.validationErrors.flightnumberMain, error: validation.validationErrors.flightnumberMainWrongFormat }">
                <label>
                    <h5>
                        {{ mainFlightnumberFieldText }}
                    </h5>
                    <input type="text" name="flightnumber_main" v-model="caseData.flightnumber_main"/>
                </label>
                <small class="error" v-if="validation.validationErrors.flightnumberMain">Bitte geben Sie eine Flugnummer ein.</small>
                <small class="error" v-if="validation.validationErrors.flightnumberMainWrongFormat">Bitte geben Sie die Flugnummer nur mit Buchstaben und Zahlen sowie ohne Leerzeichen ein.</small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns">
                <div class="alert-box alert" v-if="mainFlightnumberCheckText">
                    {{ mainFlightnumberCheckText }}
                </div>
            </div>
        </div>

        <div class="row" v-if="viewData.hasStopover">
            <div class="small-12 medium-6 columns" v-bind:class="{ error: validation.validationErrors.subAirlineId }">
                <label>
                    <h5>Fluglinie 2 (Zwischenstopp - Ziel)</h5>
                    <p style="font-size: small; margin: 0;">
                        Hier die Fluglinie eintragen, die den ursprünglich annullierten, verspäteten oder vorverlegten Flug
                        <em>durchgeführt</em> hat oder durchführen sollte (wichtig wenn der Flug über eine andere
                        Fluglinie gebucht wurde).
                    </p>
                </label>
                <vue-simple-suggest
                    display-attribute="name"
                    value-attribute="name"
                    :list="airlines"
                    :filter-by-query="true"
                    :debounce="200"
                    @select="onSuggestSelectSubAirline"
                    v-model="viewData.subAirlineName"
                />
                <div class="alert-box alert" v-if="subAirlineCodeHintText">
                    {{ subAirlineCodeHintText }}
                </div>
                <small class="error" v-if="validation.validationErrors.subAirlineId">
                    Bitte wählen Sie eine Fluglinie aus der Liste aus.
                </small>
            </div>
        </div>

        <div class="row" v-if="viewData.hasStopover" v-bind:class="{ error: validation.validationErrors.flightnumberSub, error: validation.validationErrors.flightnumberSubWrongFormat }">
            <div class="small-12 medium-3 columns">
                <label>
                    <h5>Flugnummer 2 (Zwischenstopp - Ziel)</h5>
                    <input type="text" name="flightnumber_sub" v-model="caseData.flightnumber_sub"/>
                </label>
                <small class="error" v-if="validation.validationErrors.flightnumberSub">Bitte geben Sie eine Flugnummer ein.</small>
                <small class="error" v-if="validation.validationErrors.flightnumberSubWrongFormat">Bitte geben Sie die Flugnummer nur mit Buchstaben und Zahlen sowie ohne Leerzeichen ein.</small>
            </div>
        </div>
        <div class="row">
            <div class="small-12 medium-6 columns">
                <div class="alert-box alert" v-if="subFlightnumberCheckText">
                    {{ subFlightnumberCheckText }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="small-12 columns">
                <button class="button" @click.stop="calculateCompensation" :disabled="viewData.isSendButtonDisabled">
                    <span>Weiter</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Errors from '../components/Errors';
import {calculateCompensation, getAirlines} from '../api/flights';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import CaseTypes from '../constants/CaseTypes';
import moment from 'moment';
import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import CauseTypes from '../constants/CauseTypes';
import AmbiguousAirlines from '../constants/AmbiguousAirlines';
import RadioButtonValues from '../constants/RadioButtonValues';
import {checkCaseNotCompensable} from '../helper/CompensationHelper';
import {isNotNullOrUndefined, isNullOrUndefinedOrEmpty} from '../helper/TypeHelper';

export default {
    name: 'StartPage',
    components: {Errors, VueGoogleAutocomplete, Datepicker, VueSimpleSuggest},
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    start: null,
                    start_longitude: null,
                    start_latitude: null,
                    start_country: null,
                    end: null,
                    end_longitude: null,
                    end_latitude: null,
                    end_country: null,
                    stopover: null,
                    type: null,
                    planned_relevant_date: null,
                    actual_relevant_date: null,
                    cause: null,
                    was_late_for_boarding: null,
                    was_boarding_lateness_acceptable: null,
                    flightnumber_main: null,
                    flightnumber_sub: null,
                    distance: null,
                    flightdate: null,
                    main_airline_id: null,
                    sub_airline_id: null,
                    rsv_id: null
                }
            }
        }
    },
    data: () => ({
        de: de,
        viewData: {
            hasStopover: false,
            hasNotArrived: false,
            isSendButtonDisabled: false,
            mainAirlineName: null,
            subAirlineName: null
        },
        dates: {
            flightdate: null
        },
        validation: {
            validationErrors: {
                start: false,
                end: false,
                stopover: false,
                type: false,
                flightdate: false,
                plannedRelevantDate: false,
                actualRelevantDate: false,
                actualRelevantDateNotArrived: false,
                cause: false,
                wasLateForBoarding: false,
                wasBoardingLatenessAcceptable: false,
                flightnumberMain: false,
                flightnumberMainWrongFormat: false,
                flightnumberSub: false,
                flightnumberSubWrongFormat: false,
                mainAirlineId: false,
                subAirlineId: false
            },
        },
        errorInformation: {
            showAirlinesLoadError: false,
            showGeneralError: false,
            generalErrorMessage: null,
            showValidationError: false
        },
        airlines: [],
        maxDatetime: moment().toISOString(),
        datepickerDisabledDates: { from: new Date(Date.now()) },
        availableCaseTypes: CaseTypes.toArray(),
        availableCauseTypes: CauseTypes.toArray(),
        defaultRadioValues: [RadioButtonValues.YES, RadioButtonValues.NO],
        constants: {
            SCROLL_TO_TOP_EVENT: 'scrollToTop',
            GO_TO_CALCULATE_PAGE_EVENT: 'goToCalculatePage',
            FLIGHTNUMBER_REGEX: /^[0-z]*$/
        }
    }),
    methods: {
        async setStartAddress (addressData, placeResultData)
        {
            this.resetStartAddress();

            this.caseData.start_country = await this.getCountryShortname(placeResultData.address_components);
            if(!this.caseData.start_country) {
                this.caseData.start_country = await this.fetchCountryFromOpenStreetMap(placeResultData.geometry)
            }
            this.caseData.start_latitude = addressData.latitude;
            this.caseData.start_longitude = addressData.longitude;
        },
        setStartText(text)
        {
            this.caseData.start = text;
        },
        resetStartAddress: function ()
        {
            this.caseData.start = null;
            this.caseData.start_country = null;
            this.caseData.start_latitude = null;
            this.caseData.start_longitude = null;
            this.caseData.distance = null;
        },
        async setEndAddress (addressData, placeResultData)
        {
            this.resetEndAddress();

            this.caseData.end_country = await this.getCountryShortname(placeResultData.address_components);
            if(!this.caseData.end_country) {
                this.caseData.end_country = await this.fetchCountryFromOpenStreetMap(placeResultData.geometry)
            }
            this.caseData.end_latitude = addressData.latitude;
            this.caseData.end_longitude = addressData.longitude;
        },
        setEndText(text)
        {
            this.caseData.end = text;
        },
        resetEndAddress: function ()
        {
            this.caseData.end = null;
            this.caseData.end_country = null;
            this.caseData.end_latitude = null;
            this.caseData.end_longitude = null;
            this.caseData.distance = null;
        },
        // extract country short name (e.g. GB for Great Britain) from google geocode API result
        // see https://stackoverflow.com/questions/19248012/json-google-geocode-api-get-country
        async getCountryShortname(addrComponents) {
            for (let i = 0; i < addrComponents.length; i++) {
                if (addrComponents[i].types[0] === 'country') {
                    return addrComponents[i].short_name;
                }
            }
            return false;
        },
        async fetchCountryFromOpenStreetMap(geometry) {
            const lat = geometry.location.lat();
            const lon = geometry.location.lng();
            const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`;
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const data = await response.json();

                // Sichere Prüfung ohne optionalen Chaining-Operator
                if (data && data.address && data.address.country_code) {
                    return data.address.country_code.toUpperCase();
                }
                return null;
            } catch (error) {
                throw error;
            }
        },
        setStopoverText(text)
        {
            this.caseData.stopover = text;
        },
        onSuggestSelectMainAirline(suggest)
        {
            this.caseData.main_airline_id = suggest.id;
        },
        onSuggestSelectSubAirline(suggest)
        {
            this.caseData.sub_airline_id = suggest.id;
        },
        getAirlineById(id)
        {
            return this.airlines.find((airline) => airline.id === id);
        },
        toogleStopover()
        {
            this.viewData.hasStopover = !this.viewData.hasStopover;
        },
        async calculateCompensation()
        {
            this.viewData.isSendButtonDisabled = true;
            this.errorInformation.showGeneralError = false;
            this.validateForm();

            if (this.errorInformation.showValidationError)
                this.$emit(this.constants.SCROLL_TO_TOP_EVENT);
            else
            {
                let notCompensableReason = checkCaseNotCompensable(this.caseData);

                if (notCompensableReason === null)
                {
                    try
                    {
                        let requestData = {
                            flightData: {
                                plannedRelevantDate: this.caseData.planned_relevant_date,
                                actualRelevantDate: this.caseData.actual_relevant_date,
                                type: this.caseData.type,
                                airlineId: this.caseData.main_airline_id,
                            },
                            startPosition: {
                                latitude: this.caseData.start_latitude,
                                longitude: this.caseData.start_longitude,
                                country: this.caseData.start_country
                            },
                            endPosition: {
                                latitude: this.caseData.end_latitude,
                                longitude: this.caseData.end_longitude,
                                country: this.caseData.end_country
                            }
                        };
                        let res = await calculateCompensation(requestData);
                        this.$emit(this.constants.GO_TO_CALCULATE_PAGE_EVENT, res);
                    }
                    catch(error)
                    {
                        this.errorInformation.showGeneralError = true;
                        this.errorInformation.generalErrorMessage = 'Fehler beim Berechnen der Entschädigung: ' + error;
                        this.$emit(this.constants.SCROLL_TO_TOP_EVENT);
                    }
                }
                else
                    this.$emit(this.constants.GO_TO_CALCULATE_PAGE_EVENT, {compensation: 0, scenario: notCompensableReason});
            }
            this.viewData.isSendButtonDisabled = false;
        },
        validateForm()
        {
            this.validation.validationErrors = {};
            this.errorInformation.showValidationError = false;

            if (isNullOrUndefinedOrEmpty(this.caseData.start))
                this.validation.validationErrors.start = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.end))
                this.validation.validationErrors.end = true;

            if (this.viewData.hasStopover && isNullOrUndefinedOrEmpty(this.caseData.stopover))
                this.validation.validationErrors.stopover = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.type))
                this.validation.validationErrors.type = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.flightdate))
                this.validation.validationErrors.flightdate = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.planned_relevant_date))
                this.validation.validationErrors.plannedRelevantDate = true;

            if (!this.isCaseTypeCanceled && isNullOrUndefinedOrEmpty(this.caseData.actual_relevant_date))
                this.validation.validationErrors.actualRelevantDate = true;
            else if (isNullOrUndefinedOrEmpty(this.caseData.actual_relevant_date) && !this.viewData.hasNotArrived)
                this.validation.validationErrors.actualRelevantDateNotArrived = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.cause) && !this.isCaseTypeNoBoarding)
                this.validation.validationErrors.cause = true;

            if (this.isCaseTypeNoBoarding && isNullOrUndefinedOrEmpty(this.caseData.was_late_for_boarding))
                this.validation.validationErrors.wasLateForBoarding = true;

            if (this.isCaseTypeNoBoarding && isNullOrUndefinedOrEmpty(this.caseData.was_boarding_lateness_acceptable))
                this.validation.validationErrors.wasBoardingLatenessAcceptable = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.main_airline_id))
                this.validation.validationErrors.mainAirlineId = true;

            if (isNullOrUndefinedOrEmpty(this.caseData.flightnumber_main))
                this.validation.validationErrors.flightnumberMain = true;
            else if (this.constants.FLIGHTNUMBER_REGEX.test(this.caseData.flightnumber_main) === false)
                this.validation.validationErrors.flightnumberMainWrongFormat = true;

            if (this.viewData.hasStopover && isNullOrUndefinedOrEmpty(this.caseData.sub_airline_id))
                this.validation.validationErrors.subAirlineId = true;

            if (this.viewData.hasStopover && isNullOrUndefinedOrEmpty(this.caseData.flightnumber_sub))
                this.validation.validationErrors.flightnumberSub = true;
            else if (this.viewData.hasStopover && this.constants.FLIGHTNUMBER_REGEX.test(this.caseData.flightnumber_sub) === false)
                this.validation.validationErrors.flightnumberSubWrongFormat = true;

            if (Object.keys(this.validation.validationErrors).length > 0)
                this.errorInformation.showValidationError = true;
        },
        selectFlightdate(newValue)
        {
            if (newValue === null)
                this.caseData.flightdate = null;
            else
                this.caseData.flightdate = moment(newValue).toISOString(true);
        }
    },
    computed: {
        isCaseTypeCanceled()
        {
            return this.caseData.type === CaseTypes.CASE_TYPE_CANCELED.value;
        },
        isCaseTypeNoBoarding()
        {
            return this.caseData.type === CaseTypes.CASE_TYPE_NO_BOARDING.value;
        },
        isActualRelevantDateDisabled()
        {
            return this.viewData.hasNotArrived;
        },
        reasonText()
        {
            switch (this.caseData.type)
            {
                case CaseTypes.CASE_TYPE_FORWARDED.value:
                    return 'Vorverlegung';
                case CaseTypes.CASE_TYPE_CANCELED.value:
                    return 'Annulierung';
                default:
                    return 'Verspätung';
            }
        },
        mainFlightnumberFieldText()
        {
            if(this.viewData.hasStopover)
            {
                return 'Flugnummer 1 (Start - Zwischenstopp)';
            }
            return 'Flugnummer';
        },
        mainAirlineNameFieldText()
        {
            if(this.viewData.hasStopover)
            {
                return 'Fluglinie 1 (Start - Zwischenstopp)';
            }
            return 'Fluglinie';
        },
        mainAirlineCodeHintText()
        {
            let airline = this.getAirlineById(this.caseData.main_airline_id);
            if (isNotNullOrUndefined(airline))
            {
                let hintText = AmbiguousAirlines.getAirlineMessageByTitle(airline.name);
                if(hintText !== null)
                {
                    hintText += ' ' + airline.codes.join(' oder ');
                }
                return hintText;
            }

            return null;
        },
        subAirlineCodeHintText()
        {
            let airline = this.getAirlineById(this.caseData.sub_airline_id);
            if (isNotNullOrUndefined(airline))
            {
                let hintText = AmbiguousAirlines.getAirlineMessageByTitle(airline.name);
                if(hintText !== null)
                {
                    hintText += ' ' + airline.codes.join(' oder ');
                }
                return hintText;
            }

            return null;
        },
        mainFlightnumberCheckText()
        {
            let me = this;
            let checkText = null;
            let airline = this.getAirlineById(this.caseData.main_airline_id);
            let isFlightNumberPossible = false;
            if(isNotNullOrUndefined(airline) && isNotNullOrUndefined(this.caseData.flightnumber_main) && this.caseData.flightnumber_main !== '')
            {
                airline.codes.forEach(function(codeData){
                    if(me.caseData.flightnumber_main.startsWith(codeData))
                    {
                        isFlightNumberPossible = true;
                    }
                });
                if(!isFlightNumberPossible)
                {
                    checkText = 'Achtung: Die von Ihnen eingebene Flugnummer beginnt nicht mit dem üblichen Kürzel dieser Fluglinie (';
                    checkText += airline.codes.join(', ');
                    checkText += '). Bitte überprüfen Sie z.B. anhand der Bordkarte, ob der Flug  nicht von einer anderen Fluglinie durchgeführt wurde und geben Sie in diesem Fall diese Fluglinie ein.';
                }
            }
            return checkText;
        },
        subFlightnumberCheckText()
        {
            let me = this;
            let checkText = null;
            let airline = this.getAirlineById(this.caseData.sub_airline_id);
            let isFlightNumberPossible = false;
            if(isNotNullOrUndefined(airline) && isNotNullOrUndefined(this.caseData.flightnumber_sub)
                && this.caseData.flightnumber_sub !== '')
            {
                airline.codes.forEach(function(codeData){
                    if(me.caseData.flightnumber_sub.startsWith(codeData))
                    {
                        isFlightNumberPossible = true;
                    }
                });
                if(!isFlightNumberPossible)
                {
                    checkText = 'Achtung: Die von Ihnen eingebene Flugnummer beginnt nicht mit dem üblichen Kürzel dieser Fluglinie (';
                    checkText += airline.codes.join(', ');
                    checkText += '). Bitte überprüfen Sie z.B. anhand der Bordkarte, ob der Flug  nicht von einer anderen Fluglinie durchgeführt wurde und geben Sie in diesem Fall diese Fluglinie ein.';
                }
            }
            return checkText;
        },
        wasLateForBoardingRadioValue()
        {
            // the values for this Radiobutton needs to be flipped, because the question in the UI has a different wording
            // in comparison to the database-field
            return [
                {
                    value: RadioButtonValues.NO.value,
                    text: RadioButtonValues.YES.text
                },
                {
                    value: RadioButtonValues.YES.value,
                    text: RadioButtonValues.NO.text
                }
            ]
        },
        stopoverButtonText()
        {
            let text = 'Zwischenstopp ';

            text += this.viewData.hasStopover ? 'entfernen' : 'hinzufügen';

            return text;
        },
        actualRelevantDateLabel()
        {
            if (this.caseData.type === CaseTypes.CASE_TYPE_FORWARDED.value)
                return 'Tatsächliche Abflugszeit am Startflughafen';
            else
                return 'Tatsächliche Ankunftszeit am Zielflughafen';
        },
        plannedRelevantDateLabel()
        {
            if (this.caseData.type === CaseTypes.CASE_TYPE_FORWARDED.value)
                return 'Geplante Abflugszeit am Startflughafen';
            else
                return 'Geplante Ankunftszeit am Zielflughafen';
        },
        actualRelevantDateTitle()
        {
            if (this.caseData.type === CaseTypes.CASE_TYPE_FORWARDED.value)
                return 'Tatsächliche Abflugszeit:';
            else
                return 'Tatsächliche Ankunftszeit:';
        },
        plannedRelevantDateTitle()
        {
            if (this.caseData.type === CaseTypes.CASE_TYPE_FORWARDED.value)
                return 'Geplante Abflugszeit:';
            else
                return 'Geplante Ankunftszeit:';
        }
    },
    async created()
    {
        if (isNotNullOrUndefined(this.caseData.stopover))
            this.viewData.hasStopover = true;

        if ((this.caseData.actual_relevant_date === null || this.caseData.actual_relevant_date === undefined)
            && this.caseData.type === CaseTypes.CASE_TYPE_CANCELED.value)
            this.viewData.hasNotArrived = true;

        if (isNotNullOrUndefined(this.caseData.flightdate))
            this.dates.flightdate = moment(this.caseData.flightdate).toDate();

        try
        {
            this.airlines = await getAirlines();

            if (isNotNullOrUndefined(this.caseData.main_airline_id))
                this.viewData.mainAirlineName = this.getAirlineById(this.caseData.main_airline_id).name;

            if (isNotNullOrUndefined(this.caseData.sub_airline_id))
                this.viewData.subAirlineName = this.getAirlineById(this.caseData.sub_airline_id).name;
        }
        catch (error)
        {
            this.errorInformation.showAirlinesLoadError = true;
            this.$emit(this.constants.SCROLL_TO_TOP_EVENT);
        }
    },
    watch:
    {
        'viewData.mainAirlineName': function(newValue)
        {
            if (isNullOrUndefinedOrEmpty(newValue))
                this.caseData.main_airline_id = null;
        },
        'viewData.subAirlineName': function(newValue)
        {
            if (isNullOrUndefinedOrEmpty(newValue))
                this.caseData.sub_airline_id = null;
        },
        'viewData.hasNotArrived': function(newValue)
        {
            if (newValue)
            {
                this.caseData.actual_relevant_date = null;

                this.validation.validationErrors.actualRelevantDate = false;
                this.validation.validationErrors.actualRelevantDateNotArrived = false;
            }
        },
        'viewData.hasStopover': function(newValue)
        {
            if (newValue === false)
            {
                this.caseData.stopover = null;
                this.caseData.sub_airline_id = null;
                this.caseData.flightnumber_sub = null;

                this.validation.validationErrors.stopover = false;
                this.validation.validationErrors.subAirlineId = false;
                this.validation.validationErrors.flightnumberSub = false;
            }
        },
        'caseData.type': function()
        {
            if (this.isCaseTypeNoBoarding)
            {
                this.caseData.cause = null;

                this.validation.validationErrors.cause = false;
            }
            else
            {
                this.caseData.was_late_for_boarding = null;
                this.caseData.was_boarding_lateness_acceptable = null;

                this.validation.validationErrors.wasLateForBoarding = false;
                this.validation.validationErrors.wasBoardingLatenessAcceptable = false;
            }

            this.viewData.hasNotArrived = false;
        }
    }
};
</script>

<style>
h5 {
    font-weight: bold;
    font-size: 1.2rem;
    color: #4d4d4d;
    margin: 1.5rem 0 1rem 0;
}

input.short {
    width: 100%;
    max-width: 200px;
    box-sizing: border-box;
}

button[type="submit"] {
    font-weight: bold;
}

/* Consistent space between radio options */

.small-11 {
    margin-bottom: 15px;
}

/* Datetimepicker */

.vdatetime-popup__header,
.vdatetime-calendar__month__day--selected > span > span,
.vdatetime-calendar__month__day--selected:hover > span > span {
    background: #3c3c3c !important;
}

.vdatetime-year-picker__item--selected,
.vdatetime-time-picker__item--selected,
.vdatetime-popup__actions__button {
    color: #e10065 !important;
}

/* Autosuggest */

.vue-simple-suggest.designed .suggestions .suggest-item.selected {
    background-color: #3c3c3c !important;
}

.vue-simple-suggest.designed .suggestions .suggest-item.hover {
    background-color: #3c3c3c !important;
}

.vue-simple-suggest.designed .default-input {
    color: rgba(0, 0, 0, 0.75) !important;
}

.checkbox-margin {
    margin-right: 2px;
}
</style>
